import React from "react";
import { navLinks } from "../../mock";

export default function Navigation({ onBook }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="oi-nav scrolled">
      <button
        className="nav-brand"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Начало"
      >
        Юзлем Идриз
      </button>
      <nav className="nav-links">
        {navLinks.map((link) => (
          <button
            key={link.target}
            className="nav-link"
            onClick={() => scrollTo(link.target)}
          >
            {link.label}
          </button>
        ))}
      </nav>
      <button className="btn-talk" onClick={() => onBook()}>
        Нека поговорим
      </button>
    </header>
  );
}
